module.exports = __webpack_public_path__ + "static/img/2areaB_25.e569fe6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_25.png
// module id = 1150
// module chunks = 1